import React, { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import {
  EOrderTab,
  ILongSteelOrderData,
  IOpenOrderData,
  IBilledOrderData,
  EOrderType
} from '../../../../../store/ducks/long-steel-orders/types';

import moment from 'moment';
import { LongSteelOrdersService } from '../../../../../services/LongSteelOrders';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';
import { ITaggingParams } from '../../../../../store/ducks/tagging/types';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { useDispatch, useSelector } from 'react-redux';
import { createXMLTable } from '../../../../../utils/createXMLTable';
import OpenOrderTableContentToExcel from './OpenOrderTableContentToExcel';
import BilledOrderTableContentToExcel from './BilledOrderTableContentToExcel';
import { MarketingCloudService } from '../../../../../services/MarketingCloud';
import { ApplicationState } from '../../../../../store';

interface IExportOrdersProps {
  orders: ILongSteelOrderData[];
  orderTab: EOrderTab;
  disableClick?: boolean;
}

const ExportOrders: React.FC<IExportOrdersProps> = ({
  orders,
  orderTab,
  disableClick
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userState = useSelector((state: ApplicationState) => state.user);

  const dispatchExportExcelTagging = () => {
    const taggingParams: ITaggingParams = {
      screenName:
        orderTab === EOrderTab.OPEN
          ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos'
          : 'LG:MeusPedidos:AcosLongos:PedidosFaturados',
      event: 'click',
      itemName: 'button:baixar_excel',
      itemDescription:
        orderTab === EOrderTab.OPEN
          ? 'meus_pedidos_acosLongos_pedidosAbertos_baixarExcel'
          : 'meus_pedidos_acosLongos_pedidosFaturados_baixarExcel'
    };

    dispatch(sendTagging(taggingParams));
  };

  const downloadExcel = async () => {
    dispatchExportExcelTagging();
    setLoading(true);
    let fileName = '';
    const today = moment().format('DD/MM/YYYY');
    let tableContent = '';

    if (orderTab === EOrderTab.BILLED) {
      fileName = `Histórico de faturamento Gerdau - ${today}.xls`;
      tableContent = createXMLTable(
        ReactDOMServer.renderToString(
          <BilledOrderTableContentToExcel
            orders={orders as IBilledOrderData[]}
          />
        ),
        fileName
      );
    } else {
      // EOrderTab.OPEN
      fileName = `Carteira de pedidos Gerdau - ${today}`;
      const openOrders = orders as IOpenOrderData[];

      const hasSomeFlatItem: boolean = openOrders.some(
        (item) => item.orderType === EOrderType.PLANOS
      );

      if (hasSomeFlatItem) {
        const orderSvc = new LongSteelOrdersService();
        const flatSteelItems = openOrders.filter(
          (item) => item.orderType === EOrderType.PLANOS
        );

        await orderSvc.getTrackingFlatSteelExcel(
          flatSteelItems,
          userState.searchCustomerType
        );
      }

      tableContent = createXMLTable(
        ReactDOMServer.renderToString(
          <OpenOrderTableContentToExcel
            orders={openOrders}
            hasSomeFlatItem={hasSomeFlatItem}
          />
        ),
        fileName
      );
    }

    setLoading(false);
    const element = document.createElement('a');
    element.setAttribute(
      'href',
      'data:application/vnd.ms-excel,' + encodeURIComponent(tableContent)
    );
    element.setAttribute('download', fileName);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    MarketingCloudService.sendEvent({
      type: 'long-steel-orders',
      downloadExcel: true
    });
  };

  return (
    <Button
      name="exportDuplicate"
      onClick={downloadExcel}
      icon={<Icon option="XLS" />}
      iconPosition="left"
      variant="secondary"
      disabled={disableClick || loading}
      loading={loading}
    >
      Baixar tabela em excel
    </Button>
  );
};

export default ExportOrders;
